<template>
	<v-card :rounded="$vuetify.breakpoint.smAndDown ? '0' : 'lg'">
		<div class="text-center">
			<v-img
					:height="70"
					class="rounded-t-lg"
					src="@/assets/images/profile/cover.jpg"
			/>
			<AvatarComponent
					:first-name="currentUser?.firstName ?? ' '"
					:last-name="currentUser?.lastName ?? ' '"
					:profile-image="currentUser?.profilePhotoX128"
					:size="64"
					class="mt-n9"
					first
					grouped
			/>
			<v-card-text class="pt-0">
				<v-list-item-content v-if="currentUser">
					<v-list-item-title>
						<router-link
								:to="{
									name: 'userProfile',
									params: { userId: currentUser.id },
								}"
								class="text-decoration-none black--text font-weight-bold"
						>
							{{ currentUser.firstName }} {{ currentUser.lastName }}
						</router-link>
					</v-list-item-title>
					<v-list-item-subtitle>
						{{ currentUser.shortAbout }}
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-card-text>
		</div>
	</v-card>
</template>

<script>
import { mapGetters } from "vuex";
import AvatarComponent from "@/components/profile/AvatarComponent.vue";

export default {
  components: {
    AvatarComponent,
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser",
    }),
  },
};
</script>
